import { useState } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

import { Send } from 'react-feather'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../../lib/firbase'
import AnimatedBackground from '../common/AnimatedBackground'
import './SubmitFeedback.css'

export default function SubmitFeedback() {
    const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    feedback: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus(null)

    try {
      await addDoc(collection(db, 'feedback'), {
        ...formData,
        timestamp: serverTimestamp()
        
      })
      navigate('/thank-you') 
      
      setSubmitStatus({
        type: 'success',
        message: 'Thank you for your feedback!'
      })
      setFormData({ name: '', company: '', feedback: '' })
    } catch (error) {
      console.error('Error submitting feedback:', error)
      setSubmitStatus({
        type: 'error',
        message: 'Failed to submit feedback. Please try again.'
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <section className="submit-feedback-section">
      <AnimatedBackground/>
      <div className="submit-feedback-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="submit-feedback-header"
        >
          <h1>Share Your <span className="gradient-text">Experience</span></h1>
          <p>We value your feedback! Help us improve our services.</p>
        </motion.div>

        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="feedback-form"
          onSubmit={handleSubmit}
        >
          <div className="form-group">
            <label htmlFor="name">Your Name </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              
              placeholder="John Doe"
            />
          </div>

          <div className="form-group">
            <label htmlFor="company">Company *</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
              placeholder="Your Company Name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="feedback">Your Feedback *</label>
            <textarea
              id="feedback"
              name="feedback"
              value={formData.feedback}
              onChange={handleChange}
              required
              placeholder="Share your experience with us..."
              rows={6}
            />
          </div>

          {submitStatus && (
            <div className={`submit-status ${submitStatus.type}`}>
              {submitStatus.message}
            </div>
          )}

          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
            {!isSubmitting && <Send className="button-icon" />}
          </button>
        </motion.form>
      </div>
    </section>
  )
}

